<rt-box [variant]="'background-light no-padding'" layout-vertical margin-lr margin-bottom>
  @for (rating of ratings(); track rating.admin.id; let last = $last) {
    <div class="rating-row" padding-tb-small>
      <div layout layout-align-items-center min-width-0 padding-left padding-right-small-x>
        <rt-avatar
          [type]="rating.admin.hasAvatar ? 'image' : 'initials'"
          [size]="'small'"
          [shape]="'oval'"
          [imageSrc]="rating.admin.photoThumbUrl"
          [initials]="rating.admin.initials"
          margin-right-small-x
          margin-top-small-xx
        />
        <span
          [rtTooltip]="rating.admin.name"
          [rtTooltipEnableWhenTruncated]="true"
          class="admin-name"
          text-darkest
          >{{ rating.admin.name }}</span
        >
      </div>

      <div layout-vertical min-width-0 padding-right>
        <rt-evaluation-skill-scale-rating [rating]="rating" [status]="rating.status" />
      </div>
    </div>
    @if (!last) {
      <rt-divider />
    }
  }
</rt-box>
